module.exports = __webpack_public_path__ + "img/dark-personal-portfolio-landing.b470e869.webp";